/**
 * Enter 项目通用外部链接（基础 URL，不带 UTM 参数）
 */
export const EXTERNAL_LINKS = {
    /** Discord 社区 */
    DISCORD: 'https://discord.com/invite/5FZjchgfb6',
    /** 论坛 */
    FORUM: 'https://enter.converge.ai/forum',
    /** 更新日志 */
    CHANGELOG: 'https://enter.converge.ai/blog/enters-changelog',
    /** 博客 */
    BLOG: 'https://enter.converge.ai/blog',
    /** Skills 介绍博客 */
    INTRODUCING_ENTER_SKILLS: 'https://enter.converge.ai/blog/introducing-enter-skills',
    /** X (Twitter) */
    X: 'https://x.com/EnterProAI',
    /** TikTok */
    TIKTOK: 'https://www.tiktok.com/@enter.pro.ai',
    /** YouTube */
    YOUTUBE: 'https://www.youtube.com/@EnterProAI',
    /** LinkedIn */
    LINKEDIN: 'https://www.linkedin.com/company/enterproai/',
    /** Framia */
    FRAMIA: 'https://framia.converge.ai',
    /** Combos */
    COMBOS: 'https://combos.fun/',
    /** Concat */
    CONCAT: 'https://concat.pro/',
    /** AnyCap */
    ANYCAP: 'https://anycap.ai/',
} as const;
